import { ContractModel } from "@/core/models/contracts/contract.model";
import { ContractRepo } from "@/core/repos/tables/contract.repo";
import { AppUserModel } from "@/core/models/app-user.model";
import { AppUserRepo } from "@/core/repos/tables/app-user.repo";
import container from "@/lib/di/container";
import { Select } from "antd";
import { useState, useEffect } from "react";
import { useDebounce } from "use-debounce";

const contractRepo = container.get(ContractRepo);
const appUserRepo = container.get(AppUserRepo);

export type SearchType = 'WaterUser' | 'AppUser';

interface ContractSelectProps {
    value?: string;
    onChange?: (value: string) => void;
    placeholder?: string;
    className?: string;
    disabled?: boolean;
    searchType?: SearchType;
    style?: React.CSSProperties;
}

export const ContractSelect: React.FC<ContractSelectProps> = ({
    value,
    onChange,
    placeholder = "Nhập Mã KH, Tên KH, ...",
    className,
    disabled,
    searchType = 'WaterUser',
    style
}) => {
    const [contractOptions, setContractOptions] = useState<ContractModel[]>([]);
    const [userOptions, setUserOptions] = useState<AppUserModel[]>([]);
    const [searchQuery, setSearchQuery] = useState<string>("");
    const [debouncedSearchQuery] = useDebounce(searchQuery, 200);

    const fetchContracts = async (search?: string) => {
        const contracts = await contractRepo.getData(1, {search}, 20);
        if (contracts) {
            setContractOptions(contracts.data);
        }
    }

    const fetchUsers = async (search?: string) => {
        const users = await appUserRepo.getData(1, {search}, 20);
        if (users) {
            setUserOptions(users.data);
        }
    }

    const fetchData = async (search?: string) => {
        if (searchType === 'WaterUser') {
            await fetchContracts(search);
        } else {
            await fetchUsers(search);
        }
    }

    const init = async () => {
        await fetchData();
    }

    useEffect(() => {init()}, [searchType]);

    useEffect(() => {
        fetchData(debouncedSearchQuery);
    }, [debouncedSearchQuery, searchType]);

    return (
        <Select
            showSearch
            value={value}
            onChange={onChange}
            onSearch={(query) => setSearchQuery(query)}
            notFoundContent={null}
            defaultActiveFirstOption={false}
            placeholder={placeholder}
            filterOption={false}
            className={className}
            disabled={disabled}
            style={style}
            options={searchType === 'WaterUser' 
                ? contractOptions.map(contract => ({
                    label: `${contract.code} - ${contract.name} - Khách hàng`,
                    value: contract.code
                }))
                : userOptions.map(user => ({
                    label: `${user.userName} - ${user.fullName} - Nhân viên`,
                    value: user.userName
                }))
            }
        />
    );
};